<template>
  <register-container style="height: 100%" :contentStyle="{ height: '100%', position: 'relative' }">
    <div
      style="
        margin: auto;
        max-width: 800px;
        position: absolute;
        inset: 0px;
        padding: 16px;
        height: fit-content;
        max-height: 100%;
        overflow: auto;
      "
      :style="{
        transform: `translateY(calc(-${$vuetify.breakpoint.smAndDown ? '70px' : '107px'} * 0.5))`,
      }"
      class="pa-4 text-center flex-grow-1"
    >
      <header class="mt-6" style="max-width: 400px; margin: auto">
        <div>
          <h2>Your prescription has been sent to your pharmacist.</h2>

          <p style="font-size: 0.9rem" class="mt-6">
            Please see your pharmacist for your next steps.
          </p>
          <p style="font-size: 0.7rem" class="mt-4 font-italic">You may now close this window.</p>
        </div>
      </header>
      <!-- <v-alert
        color="info"
        text
        v-if="!isReturningPatient"
        style="width: fit-content; margin: auto"
      >
        <p>Don't forget to get you lab work done.</p>
        <p>You can access your lab requisition at our secure portal:</p>
        <v-btn elevation="0" style="width: 200px" color="info" @click="goPortal"> Portal </v-btn>
      </v-alert> -->
      <!-- <div class="mt-12" style="gap: 8px">
        <HoverButton color="primary" @click="end" large>End intake</HoverButton>
      </div> -->
    </div>
  </register-container>
</template>
<script>
import RegisterContainer from '../components/RegisterContainer.vue';

export default {
  name: 'IneligiblePatient',
  components: {
    RegisterContainer,
  },
  data() {
    return {
      breakupText:
        'Based on the information provided, we are unable to continue with the intake process.',
    };
  },
  methods: {
    back() {
      window.dispatchEvent(new CustomEvent('GO_PREVIOUS_PAGE'));
    },
    end() {
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
    goPortal() {
      window.open('https://access.sentryhealth.dev/login/demo', '_blank');
    },
  },
  computed: {
    isReturningPatient() {
      return this.$store.state.registration.isReturningPatient;
    },
  },
};
</script>
